import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { vendureCacheConfig } from "@/api/vendure/cache.config";
import type { DeliveryMethod } from "@/api/vendure/merchant/merchant.types";
import { DELIVERY_METHOD_TYPE } from "@/api/vendure/merchant/merchant.types";
import { ORDER_SOURCE } from "@/api/vendure/order/order.types";
import { vendure } from "@/lib/vendure";
import type { MenuCategory, MenuResponse } from "./menu.types";

const fetchMenu = createServerFn({ method: "POST" })
  .inputValidator((d: { token: string; type: number; timestamp?: number }) => d)
  .handler(async ({ data }): Promise<MenuCategory[]> => {
    const { data: response } = await vendure.get<unknown>(
      `/api/v1/menu/business/${data.token}`,
      {
        params: {
          type: data.type,
          orderSource: ORDER_SOURCE,
          ...(data.timestamp ? { timestamp: data.timestamp } : {}),
        },
      },
    );
    const r = response as MenuResponse;
    return r.result.categories ?? [];
  });

export const menuQueryOptions = (
  token: string,
  method: DeliveryMethod,
  timestamp?: number,
) =>
  queryOptions({
    queryKey: ["menu", token, method, timestamp ?? null],
    queryFn: () =>
      fetchMenu({
        data: { token, type: DELIVERY_METHOD_TYPE[method], timestamp },
      }),
    ...vendureCacheConfig,
    enabled: !!token,
  });
